import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  { name: "InductIQ", url: "https://inductiq.ai", description: "Records and training." },
  { name: "WorkSafeStory", url: "https://worksafestory.com", description: "Why I work safe." },
  { name: "HazardLoop", url: "https://hazardloop.com", description: "Action and closeout." },
  { name: "CCTV", url: "https://wsafe.si", description: "" },
  { name: "Hub", url: "https://worksafeagent.com", description: "" },
];

export const Products = () => {
  return (
    <section id="products" data-testid="products-section" className="bg-slate-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-widest text-safety">
            The WorkSafeAgent family
          </p>
          <h2 className="mt-3 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            One family of tools, built for the field
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((product, i) => (
            <motion.a
              key={product.name}
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-card-${product.name.toLowerCase()}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="group rounded-xl border border-slate-200 bg-white p-7 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-safety hover:shadow-md"
            >
              <div className="flex items-start justify-between">
                <h3 className="text-xl font-semibold text-navy">{product.name}</h3>
                <ArrowUpRight
                  className="h-5 w-5 text-slate-400 transition-colors duration-200 group-hover:text-safety"
                  aria-hidden="true"
                />
              </div>
              <p className="mt-3 text-base text-slate-600">{product.description}</p>
              <p className="mt-4 text-sm font-medium text-slate-400">
                {product.url.replace("https://", "")}
              </p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
